<template>
  <div>
    <div class=" is-fullwidth">
      <div class="buttons is-pulled-left" v-if="this.area == 'makeup'">
        <button class="button " v-for="row in makeup_locations" @click="updateMakeupLocation(row.id)" :class="{'is-success' : makeup_location_id == row.id}" :key="row.id">{{ row.name }}</button>
        
          <button class="button "  @click="updateMakeupLocation('')" :class="{'is-success' : makeup_location_id == ''}">All</button>
        
      </div>
      <div class="is-pulled-right">
        <button class="button is-warning" @click="showCompleteError()" style="display:none">Export to CSV</button>
      </div>
    </div>
    
    <div class="notification is-info" v-if="loading == true " style="clear:both">Loading requests ...</div>

    <div class="notification is-success" v-if="loading == false && this.samples.length == 0 " style="clear:both">You have no open sample requests to view</div>

    <div v-if="loading==false && this.newSamples.length > 0" class="mb-6" style="clear:both">
      <h2 class="title">New Requests (Not Submitted Yet)</h2>

      <ListSamplesTable :samples="newSamples" @open-modal="openProcessModal"/>

      
    </div>
    <!-- end of new samples-->
    
    <div v-if="loading==false && this.returnedSamples.length > 0" class="mb-6" style="clear:both">
      <h2 class="title">Returned Requests (Requires Action From You)</h2>
      <ListSamplesTable :samples="returnedSamples" />
      
    </div>
    <!-- end of returned samples-->

    <div v-if="loading==false && this.inProgressSamples.length > 0" style="clear:both">
      <h2 class="title">In Progress</h2>
      <ListSamplesTable :samples="inProgressSamples" />
      
    </div>
    <!-- end of in progress samples -->
    
    <div v-if="loading==false && this.samples.length > 0" class="mt-6">
      <p class="has-background-link-light">Requests showing in blue are not yet processed from incoming requests.</p>
      <p class="has-background-success-light">Requests in green have been processed and are now in production.</p>
    </div>

    
  </div>
</template>

<script>



import SampleService from '@/services/SampleService.js';
//import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

import ListSamplesTable from "./ListSamplesTable.vue";

export default {
  components: {
        ListSamplesTable
      },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
       orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      makeup_locations: [],
      makeup_location_id: '',
      order_by: 'deliverydate ASC',
      samples: [],
      selected_sample_id: 0,
      
    }
  },
   methods: {
    updateMakeupLocation(new_location_id)
    {
        this.makeup_location_id = new_location_id
        this.getSamples()
    },
    showCompleteError() {
        alert("This button does not action anything. ")
    },
    viewRequest(id)
    {
        this.$router.push("/samples/view/" + id);
    },
    async getSamplesMakeupLocations() {
        SampleService.getSamplesMakeupLocations(this.accessToken)
        .then(
          (makeup_locations => {
            this.$set(this, "makeup_locations", makeup_locations);
          }).bind(this)
        );
      },
      async getSamples() {
        this.loading=true
        if(this.area == "artwork")
        {
          
          SampleService.getSamplesForArtwork(this.accessToken)
          .then(
            (samples => {
              this.$set(this, "samples", samples);
              this.loading=false
            }).bind(this)
          );
        }
        else if(this.area == "digital_print")
        {
          
          SampleService.getSamplesForDigitalPrint(this.accessToken)
          .then(
            (samples => {
              this.$set(this, "samples", samples);
              this.loading=false
            }).bind(this)
          );
        }
         else if(this.area == "gerber_cutting")
        {
          
          SampleService.getSamplesForGerberCutting(this.accessToken)
          .then(
            (samples => {
              this.$set(this, "samples", samples);
              this.loading=false
            }).bind(this)
          );
        }
         else if(this.area == "sundries")
        {
          
          SampleService.getSamplesForSundries(this.accessToken)
          .then(
            (samples => {
              this.$set(this, "samples", samples);
              this.loading=false
            }).bind(this)
          );
        }
        else if(this.area == "makeup")
        {
          
          SampleService.getSamplesForMakeup(this.accessToken, this.makeup_location_id)
          .then(
            (samples => {
              this.$set(this, "samples", samples);
              this.loading=false
            }).bind(this)
          );
        }
        else if(this.area == "mysamples")
        {
          
          SampleService.getMySamples(this.accessToken)
          .then(
            (samples => {
              this.$set(this, "samples", samples);
              this.loading=false
            }).bind(this)
          );
        }
        else {
          this.samples = [];
        }
      },
      
   
    
  },
  computed : {
      newSamples: function () {
        if(this.categorise_samples == true)
        {
          let newSamples =  this.samples.filter(function(u) {
              if(  u.submitted == 0) 
              {
                return 1
              }
            })
            return newSamples
          }
          else {
            return []
          }
     },
     returnedSamples: function () {
      if(this.categorise_samples == true)
        {
        let returnedSamples =  this.samples.filter(function(u) {
            if( u.submitted==1 && u.returned == 1) 
            {
              return 1
            }
          })
          return returnedSamples
        }
        else {
          return []
        }
     },
     inProgressSamples: function () {
      if(this.categorise_samples == true)
        {
        let inProgressSamples =  this.samples.filter(function(u) {
            if(u.submitted==1 &&  u.returned == 0) 
            {
              return 1
            }
          })
          return inProgressSamples
        }
        else {
          return this.samples
        }
     },
     categorise_samples: function() {
        if(this.area == "mysamples")
        {
          return true
        }
        else {
          return false
        }
     }, 
     area: function() {
        if(this.$route.path == '/samples/list-samples/artwork')
        {
          
            return "artwork"
        }
        else if(this.$route.path == '/samples/list-samples/digital-print')
        {
          
            return "digital_print"
        }
        else if(this.$route.path == '/samples/list-samples/gerber-cutting')
        {
          
            return "gerber_cutting"
        }
        
        else if(this.$route.path == '/samples/list-samples/sundries')
        {
          
            return "sundries"
        }
        else if(this.$route.path == '/samples/list-samples/makeup')
        {
          
            return "makeup"
        }
        else if(this.$route.path == '/samples/list-samples/mysamples')
        {
         
            return "mysamples"
        }
        else {
          
          return ""
        }
    }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getSamples()
           this.getSamplesMakeupLocations()
        });
  },
 
  mounted() {
    console.log(this.area.path)
      
  },
  watch: {
    
  }
}


</script>

